import { InputHTMLAttributes, memo } from "react";
import { InputWrapper } from "./input-elements";

export interface IWrewardsDefaultInputProps {
  props: InputHTMLAttributes<HTMLInputElement>;
  wrapperProps?: React.ComponentProps<typeof InputWrapper>;
}

const WrewardsDefaultInputComponent = ({
  props,
  children,
  wrapperProps,
}: React.PropsWithChildren & IWrewardsDefaultInputProps) => {
  return (
    <InputWrapper {...wrapperProps}>
      <input autoComplete="off" {...props} />
      {children}
    </InputWrapper>
  );
};

const WrewardsDefaultInput = memo(WrewardsDefaultInputComponent);
export default WrewardsDefaultInput;
